import Admin from "pages/Admin";

export default function AdminPage() {
  return <Admin />;
}
